import { render, staticRenderFns } from "./Stairs.vue?vue&type=template&id=1fc2d69e&scoped=true&lang=pug"
import script from "./Stairs.vue?vue&type=script&lang=js"
export * from "./Stairs.vue?vue&type=script&lang=js"
import style0 from "./Stairs.vue?vue&type=style&index=0&id=1fc2d69e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc2d69e",
  null
  
)

export default component.exports